export const devConfig = {
  name: 'Development',
  baseUrl: 'https://localhost:3000',
  apiUrl: 'https://localhost:3000/api',
  // webpack-dev-server proxies /api/ai → the gateway (see webpack.config.js).
  aiProxy: 'same-origin' as const,
};
